import { downloadCSV } from "react-admin";
import jsonExport from "jsonexport/dist";

// Format helpers for export
const formatServiceRatesForExport = (services, prices) => {
  if (!services || !Array.isArray(services) || services.length === 0) return "";
  const serviceMap = {
    childcare: "CC",
    childcarePlus: "E",
    enrichment: "E",
    nightNurse: "NN",
    night_nurse: "NN",
    cleaning: "CL",
    cooking: "CK",
    housekeeping: "HK",
    virtual: "V",
    deepCleaning: "DC",
  };
  const priceKeyMap = {
    childcare: "childcare",
    childcarePlus: "childcarePlus",
    enrichment: "childcarePlus",
    nightNurse: "night_nurse",
    night_nurse: "night_nurse",
    cleaning: "cleaning",
    cooking: "cooking",
    housekeeping: "housekeeping",
    virtual: "virtual",
    deepCleaning: "deepCleaning",
  };
  return services
    .map((s) => {
      const code = serviceMap[s];
      if (!code) return null;
      const priceKey = priceKeyMap[s] || s;
      const rate = prices && prices[priceKey];
      return rate ? `${code}-$${rate}` : code;
    })
    .filter(Boolean)
    .join(", ");
};

const formatAgeRangeForExport = (min, max) => {
  if (min == null && max == null) return "";
  return `${min ?? 0}-${max ?? 18}`;
};

const formatAvailabilityForExport = (schedule) => {
  if (!schedule || !Array.isArray(schedule) || schedule.length === 0) return "";
  return schedule
    .map((day) => {
      const dayName = day.weekday || "";
      if (!dayName) return null;
      const timeStr = day.allDay
        ? "All Day"
        : `${day.startTime || ""}-${day.endTime || ""}`;
      return `${dayName}: ${timeStr}`;
    })
    .filter(Boolean)
    .join(", ");
};

const statsExporter = (records) => {
  const dataToExport = records.map((record) => ({
    Name: `${record.firstName || ""} ${record.lastName || ""}`.trim(),
    Email: record.email || "",
    Location: record.zipcode
      ? `${record.zipcode} ${record.state || ""}`.trim()
      : "",
    "Match Radius": record.operationRadius
      ? `${(record.operationRadius / 1609.34).toFixed(1)} mi`
      : "",
    "Subscription Start": record.subscriptionStartDate || "",
    "Activation Date": record.activationDate || "",
    "Req/Rec": record.reqRec || "",
    "Total Sessions": record.totalApiariSession || 0,
    Recommendations: record.recommendations || 0,
    "Bookings Received": record.bookingsReceived || 0,
    "Bookings Accepted": record.bookingsAccepted || 0,
    "Interviews Received": record.interviewsReceived || 0,
    "Interviews Accepted": record.interviewsAccepted || 0,
    "Service & Rate": formatServiceRatesForExport(
      record.services,
      record.prices,
    ),
    Reliability:
      record.reliabilityScore != null
        ? Number(record.reliabilityScore).toFixed(1)
        : "",
    "Age Range": formatAgeRangeForExport(
      record.childcareAgeRangeMin,
      record.childcareAgeRangeMax,
    ),
    Availability: formatAvailabilityForExport(record.regularSchedule),
    "Admin Notes": record.adminNotes || "",
  }));

  jsonExport(
    dataToExport,
    { headers: Object.keys(dataToExport[0] || {}) },
    (err, csv) => {
      downloadCSV(csv, "provider-stats");
    },
  );
};

export default statsExporter;
